import { ApiResponse } from 'apisauce';

import { GatewayResponse, ProtectedRoute } from '~types/gateway';

import { IDashboardGateway } from './dashboardBase';
import { TGetDashboardMarketStatusAPIResponse, TGetDashboardProductInventoryAPIParams, TGetDashboardProductInventoryAPIResponse, TGetDashboardProductPricingAPIParams, TGetDashboardProductPricingAPIResponse, TGetDashboardSilverProductPricingAPIParams, TGetDashboardSilverProductPricingAPIResponse, TGetExportDailyBalancingReportAPIParams, TGetExportDailyBalancingReportAPIResponse, TUpdateMarketStatusAPIParams } from '~types/feat/dashboard';
import UtilFunctions from '~utils/functions';

const { API: { getHeaders } } = UtilFunctions;
export default class DashboardGateway extends IDashboardGateway {
    async getDashboardProductPricing(params: TGetDashboardProductPricingAPIParams): GatewayResponse<TGetDashboardProductPricingAPIResponse> {
        const { authToken, ...restOfGetDashboardProductPricingAPIParams } = params;
        const response: ApiResponse<TGetDashboardProductPricingAPIResponse> = await this.api.get(
            '/dashboard/getProductPricing',
            { ...restOfGetDashboardProductPricingAPIParams },
            getHeaders(authToken)
        );
        return this.process(response);
    }

    async getDashboardProductInventory(params: TGetDashboardProductInventoryAPIParams): GatewayResponse<TGetDashboardProductInventoryAPIResponse> {
        const { authToken, ...restOfGetDashboardProductInventoryAPIParams } = params;

        const response: ApiResponse<TGetDashboardProductInventoryAPIResponse> = await this.api.get(
            '/inventory/getTotalInventory',
            { ...restOfGetDashboardProductInventoryAPIParams },
            getHeaders(authToken)
        );
        return this.process(response);
    }

    async getDashboardSilverProductPricing(
        params: TGetDashboardSilverProductPricingAPIParams
    ): GatewayResponse<TGetDashboardSilverProductPricingAPIResponse> {
        const { authToken } = params;
        const response: ApiResponse<TGetDashboardSilverProductPricingAPIResponse> =
        await this.api.get(
            '/dashboard/products/silver/prices',
            {},
            getHeaders(authToken)
        );
        return this.process(response);
    }

    async getDashboardMarketStatus(params: ProtectedRoute): GatewayResponse<TGetDashboardMarketStatusAPIResponse> {
        const { authToken } = params;

        const response: ApiResponse<TGetDashboardMarketStatusAPIResponse> = await this.api.get(
            '/dashboard/getMarketStatus',
            {},
            getHeaders(authToken)
        );
        return this.process(response);
    }

    async openDashboardMarket(params: ProtectedRoute & { branchCode: string }): GatewayResponse<string | undefined> {
        const { authToken, branchCode } = params;

        const response: ApiResponse<string | undefined> = await this.api.put(
            '/dashboard/openMarket',
            { branchCode },
            getHeaders(authToken)
        );
        return this.process(response);
    }

    async closeDashboardMarket(params: ProtectedRoute & { branchCode: string }): GatewayResponse<string | undefined> {
        const { authToken, branchCode } = params;

        const response: ApiResponse<string | undefined> = await this.api.put(
            '/dashboard/closeMarket',
            { branchCode },
            getHeaders(authToken)
        );
        return this.process(response);
    }

    async exportDailyBalancingReport(params: TGetExportDailyBalancingReportAPIParams): GatewayResponse<TGetExportDailyBalancingReportAPIResponse> {
        const { authToken, ...restOfExportDailyBalancingAPIParams } = params;
        const response: ApiResponse<TGetExportDailyBalancingReportAPIResponse> = await this.api.get(
            '/inventory/daily-report',
            { ...restOfExportDailyBalancingAPIParams },
            getHeaders(authToken)
        );
        return this.process(response);
    }
}
